// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiOutlinedInput-root fieldset {
  border-color: #9D9D9D;
}
.MuiOutlinedInput-root:hover fieldset {
  border-color: #9D9D9D;
}
.MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #9D9D9D;
}
.MuiOutlinedInput-root.Mui-error fieldset {
  border-color: red;
}

.message {
  margin-top: 20px;
}

.button {
  margin-top: 20px;
}

.commissioner-logo-circle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px; /* Adjust size as needed */
  height: 30px; /* Adjust size as needed */
  background-color: #00AAD1; /* Blue filled circle */
  border-radius: 50%;
  color: #FFF; /* White color for the text */
  font-weight: bold; /* Bold text */
  font-size: 16px; /* Adjust font size as needed */
}

.modal-container {
  background-color: #fefefe;
  padding: 20px; /* Padding inside the modal */
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  max-width: 600px; /* Maximum width */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* Shadow effect */
  animation: fadeIn 0.3s ease; /* Fade-in animation */
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #000; /* Text color */
  text-align: center; /* Center align text */
  font-family: "Inter", sans-serif; /* Font family */
  font-size: 23px; /* Font size */
  font-style: normal; /* Font style */
  font-weight: 800; /* Font weight */
  line-height: 150%; /* Line height */
  letter-spacing: -0.445px; /* Letter spacing */
}

.modal-creation {
  background-color: #fefefe;
  padding: 20px; /* Padding inside the modal */
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  max-width: 600px; /* Maximum width */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* Shadow effect */
  animation: fadeIn 0.3s ease; /* Fade-in animation */
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #000; /* Text color */
  text-align: center; /* Center align text */
  font-family: "Inter", sans-serif; /* Font family */
  font-size: 23px; /* Font size */
  font-style: normal; /* Font style */
  font-weight: 800; /* Font weight */
  line-height: 150%; /* Line height */
  letter-spacing: -0.445px; /* Letter spacing */
}

/* Button container to align buttons side by side */
.button-container {
  display: flex;
  justify-content: space-between;
  gap: 20px; /* Add space between buttons */
  margin-top: 20px;
}

.private-commissioner-table {
  border-left: 2px solid #002129;
}`, "",{"version":3,"sources":["webpack://./src/components/BirdiePool/BirdiePrivateGroup/PrivateGroup.scss"],"names":[],"mappings":"AAII;EACE,qBAAA;AAHN;AAKI;EACE,qBAAA;AAHN;AAKI;EACE,qBAAA;AAHN;AAKI;EACE,iBAAA;AAHN;;AAQE;EACE,gBAAA;AALJ;;AAQE;EACE,gBAAA;AALJ;;AAQE;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA,EAAA,0BAAA;EACA,YAAA,EAAA,0BAAA;EACA,yBAAA,EAAA,uBAAA;EACA,kBAAA;EACA,WAAA,EAAA,6BAAA;EACA,iBAAA,EAAA,cAAA;EACA,eAAA,EAAA,+BAAA;AALJ;;AAQE;EACE,yBAAA;EACA,aAAA,EAAA,6BAAA;EACA,sBAAA;EACA,UAAA,EAAA,oDAAA;EACA,gBAAA,EAAA,kBAAA;EACA,mBAAA,EAAA,oBAAA;EACA,yCAAA,EAAA,kBAAA;EACA,2BAAA,EAAA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA,EAAA,eAAA;EACA,kBAAA,EAAA,sBAAA;EACA,gCAAA,EAAA,gBAAA;EACA,eAAA,EAAA,cAAA;EACA,kBAAA,EAAA,eAAA;EACA,gBAAA,EAAA,gBAAA;EACA,iBAAA,EAAA,gBAAA;EACA,wBAAA,EAAA,mBAAA;AALJ;;AAQE;EACE,yBAAA;EACA,aAAA,EAAA,6BAAA;EACA,sBAAA;EACA,UAAA,EAAA,oDAAA;EACA,gBAAA,EAAA,kBAAA;EACA,mBAAA,EAAA,oBAAA;EACA,yCAAA,EAAA,kBAAA;EACA,2BAAA,EAAA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA,EAAA,eAAA;EACA,kBAAA,EAAA,sBAAA;EACA,gCAAA,EAAA,gBAAA;EACA,eAAA,EAAA,cAAA;EACA,kBAAA,EAAA,eAAA;EACA,gBAAA,EAAA,gBAAA;EACA,iBAAA,EAAA,gBAAA;EACA,wBAAA,EAAA,mBAAA;AALJ;;AAQI,mDAAA;AACF;EACE,aAAA;EACA,8BAAA;EACA,SAAA,EAAA,8BAAA;EACA,gBAAA;AALJ;;AAQE;EACE,8BAAA;AALJ","sourcesContent":["\n\n// Define styles for MUI text field\n.MuiOutlinedInput-root {\n    & fieldset {\n      border-color: #9D9D9D;\n    }\n    &:hover fieldset {\n      border-color: #9D9D9D;\n    }\n    &.Mui-focused fieldset {\n      border-color: #9D9D9D;\n    }\n    &.Mui-error fieldset {\n      border-color: red;\n    }\n  }\n\n  // Include your existing styles for .message and .button\n  .message {\n    margin-top: 20px;\n  }\n\n  .button {\n    margin-top: 20px;\n  }\n\n  .commissioner-logo-circle {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 30px; /* Adjust size as needed */\n    height: 30px; /* Adjust size as needed */\n    background-color: #00AAD1; /* Blue filled circle */\n    border-radius: 50%;\n    color: #FFF; /* White color for the text */\n    font-weight: bold; /* Bold text */\n    font-size: 16px; /* Adjust font size as needed */\n  }\n\n  .modal-container {\n    background-color: #fefefe;\n    padding: 20px; /* Padding inside the modal */\n    border: 1px solid #888;\n    width: 80%; /* Could be more or less, depending on screen size */\n    max-width: 600px; /* Maximum width */\n    border-radius: 10px; /* Rounded corners */\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* Shadow effect */\n    animation: fadeIn 0.3s ease; /* Fade-in animation */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #000; /* Text color */\n    text-align: center; /* Center align text */\n    font-family: 'Inter', sans-serif; /* Font family */\n    font-size: 23px; /* Font size */\n    font-style: normal; /* Font style */\n    font-weight: 800; /* Font weight */\n    line-height: 150%; /* Line height */\n    letter-spacing: -0.445px; /* Letter spacing */\n  }\n\n  .modal-creation {\n    background-color: #fefefe;\n    padding: 20px; /* Padding inside the modal */\n    border: 1px solid #888;\n    width: 80%; /* Could be more or less, depending on screen size */\n    max-width: 600px; /* Maximum width */\n    border-radius: 10px; /* Rounded corners */\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* Shadow effect */\n    animation: fadeIn 0.3s ease; /* Fade-in animation */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #000; /* Text color */\n    text-align: center; /* Center align text */\n    font-family: 'Inter', sans-serif; /* Font family */\n    font-size: 23px; /* Font size */\n    font-style: normal; /* Font style */\n    font-weight: 800; /* Font weight */\n    line-height: 150%; /* Line height */\n    letter-spacing: -0.445px; /* Letter spacing */\n  }\n\n    /* Button container to align buttons side by side */\n  .button-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px; /* Add space between buttons */\n    margin-top: 20px;\n  }\n\n  .private-commissioner-table{\n    border-left:2px solid #002129;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
